import { useState, useContext } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  VStack,
  Text,
  Button,
  useToast,
  Icon,
} from '@chakra-ui/react';
import { CustomSmsMultiIcon } from '../../theme/multicolor-icons/CustomSmsMultiIcon';
import { HttpContext } from '../../context/HttpContext';
import CustomToast from '../../common/CustomToast';

const ProcessNowModal = ({
  isOpen,
  onClose,
  batchId,
  batchName,
  scheduledTime,
  onProcessed,
}) => {
  const { authAxios } = useContext(HttpContext);
  const toast = useToast();
  const [isProcessing, setIsProcessing] = useState(false);

  const processNow = async () => {
    setIsProcessing(true);
    try {
      await authAxios.post(`/api/v1/batches/${batchId}/process-now`);
      toast({
        render: ({ onClose: toastClose }) => (
          <CustomToast
            status="success"
            title="Batch update queued to process now"
            description={`The previous schedule at ${scheduledTime} is cancelled. Track progress on the Batch Updates page.`}
            onClose={toastClose}
          />
        ),
      });
      if (onProcessed) {
        onProcessed();
      } else {
        window.location.reload(true);
      }
    } catch (err) {
      toast({
        render: ({ onClose: toastClose }) => (
          <CustomToast
            status="error"
            title="Something went wrong"
            description="Please try again later."
            onClose={toastClose}
          />
        ),
      });
    } finally {
      setIsProcessing(false);
      onClose();
    }
  };

  const handleProcessNowClick = () => {
    processNow();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody p={10}>
          <VStack spacing={4} py={4} textAlign="center">
            <Icon as={CustomSmsMultiIcon} w={10} h={10} />
            <Text fontSize="xl" fontWeight="semibold">
              Override schedule and process now?
            </Text>
            <Text fontSize="md">
              This will process{' '}
              <Text as="span" fontWeight="bold">
                {batchName}
              </Text>{' '}
              immediately and cancel the scheduled update at{' '}
              <Text as="span" fontWeight="bold">
                {scheduledTime}
              </Text>
              . Continue?
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter justifyContent="flex-end" gap={4}>
          <Button variant="secondary" onClick={onClose} size="sm">
            Keep Scheduled
          </Button>
          <Button
            onClick={handleProcessNowClick}
            size="sm"
            isLoading={isProcessing}
          >
            Process Now
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ProcessNowModal;
